<template>
  <div id="Dashboard"  class="container is-fluid"
    style="min-height:100vh;"
    @drop.prevent="dragFile" @dragover.prevent
  >

    <!-- Header -->
    <HeroContainer title="Special Pricing Dashboard" />

    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">


    <!-- Modal upload dialog box -->
    <div id="modal_upload" class="modal">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div style="display:flex;align-items: center;justify-content: center;">
          
          <div style="margin-bottom:1em;">
            <div style="color:#42b983; font-size:1.2em; margin-bottom:2em;">
              <p style="color:#42b983; font-size:1.5em;">Uploading:</p>
              <ul id="upload_file_names">

              </ul>
            </div>
            <p style="color:white;">
              All data will be deleted on upload and replaced with spreadsheet data!
            </p>
            <div class="buttons is-right" style="margin-top:1em">
              <button class="button is-danger" @click="cancelModal">Cancel</button>
              <button class="button is-success" @click="ajaxUpload">Submit</button>
              
            </div>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" @click="cancelModal"></button>
    </div>

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >

        <p style="margin-bottom:1em;">
          Special vendor pricing will show as a banner alert at the top of the page. 
          If a part number below is searched, the banner aler will display the vendor and the special price.
        </p>
        <p style="margin-bottom:1em;">
          Uploading a new spreadsheet (by dragging a file or using the button) will delete all records and replace them with those in the spreadsheet. 
          Alternatively, edits can be made to SpecialVendorPricing in the admin panel.
        </p>
        <input ref="fileInput" type="file" style="display:none" v-on:change="onFilePicked"/>
        <div class="buttons is-right">
          <button @click='$refs.fileInput.click()' class="button is-info">Upload Spreadsheet</button>
        </div>
      </div>
    </section>

    <section id="dashboard_data" v-if="queryData.hasOwnProperty('data')">      
      <DataTable2 
        :raw_data="queryData"
        :name="'dash_pricing'"
        :columns_from_parent="[
            {
              label: 'Part Number',
              field: 'part_number',
              type: 'text',
            },
            {
              label: 'Vendor',
              field: 'vendor',
              type: 'text',
            },
            {
              label: 'Price',
              field: 'price',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')}
            },
          ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [queryData.data, 'SpecialPricingDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>


<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import moment from 'moment';
import {
  DASHBOARD_PRICING,
  DASHBOARD_UPLOAD_SPECIAL_PRICING
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardSpecialPricing',
  components: {
    DataTable2,
    HeroContainer,
  },
  computed:{
    queryData(){
      let raw_query = {...this.queryDataRaw}
      return raw_query
    },
  },
  data: function(){
    return {
      numeral: require('numeral'),
      part_number: '',
      price_difference_low: '',
      price_difference_high: '',
      percent_difference_low: '',
      percent_difference_high: '',
      date_range: 'week',
      range: [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ],
      queryDataRaw: {},
      upload_files: [],
    };
  },
  mounted: function(){
    this.ajax_get_dashboard()
  },
  methods: {
    reset(){
      this.part_number = ''
      this.price_difference_low = ''
      this.price_difference_high = ''
      this.percent_difference_low = ''
      this.percent_difference_high = ''
      this.date_range=  'week'
      this.range = [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ]
    },
    onFilePicked (event) {
      this.upload_files = []
      let fnames = document.getElementById('upload_file_names')
      let modal = document.getElementById('modal_upload')
      const files = event.target.files
      let f = files[0]
      if(f.name.includes('.xls')){
        modal.classList.add('is-active')
        let li = document.createElement('li')
        li.innerText = f.name
        fnames.appendChild(li)
        this.upload_files.push(f);
      }else{
        alert('All files are expected to be Excel format.')
      }
    },
    dragFile(e){
      this.upload_files = []
      let fnames = document.getElementById('upload_file_names')
      let modal = document.getElementById('modal_upload')
      let droppedFiles = e.dataTransfer.files;
      if(!droppedFiles) return; 
      ([...droppedFiles]).forEach(f => {
          if(f.name.includes('.xls')){
            modal.classList.add('is-active')
            let li = document.createElement('li')
            li.innerText = f.name
            fnames.appendChild(li)
            this.upload_files.push(f);
          }else{
            alert('All files are expected to be Excel format.')
          }
        
      });
    },
    cancelModal(){
      document.getElementById('modal_upload').classList.remove('is-active')
      this.upload_files = []
      let fnames = document.getElementById('upload_file_names')
      fnames.innerText = ''
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_records(){
      this.ajax_get_dashboard(this.filter_customer, this.filter_user)
    },
    ajax_get_dashboard(){
      this.queryDataRaw = {}
      let url = DASHBOARD_PRICING
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, dashboard){
        this_vue.queryDataRaw = dashboard
      }
      fetch(url, {
        method:'GET',
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajaxUpload(){
      this.set_searching(true)
      let url = DASHBOARD_UPLOAD_SPECIAL_PRICING
      let this_vue = this
      // Aggregate the files for upload
      let formData = new FormData();
      this.upload_files.forEach((f,x) => {
        formData.append('file'+(x+1), f);
      });
      function set_dash(this_vue, dashboard){
        this_vue.queryDataRaw = dashboard
      }
      fetch(url, {
        method:'POST',
        body: formData
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
         // Display newly uploaded data
         set_dash(this_vue, res.data)
        }else{
          alert('Error: Upload error')
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
      this.cancelModal()
    },
  }
};

</script>
